import { render, staticRenderFns } from "./DataAheadSelect.vue?vue&type=template&id=1c608a44"
import script from "./DataAheadSelect.vue?vue&type=script&lang=js"
export * from "./DataAheadSelect.vue?vue&type=script&lang=js"
import style0 from "./DataAheadSelect.vue?vue&type=style&index=0&id=1c608a44&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports